/**
 * @fileoverview SPA routing powered by Navigo.
 * Each route maps to a Page class that owns its own DOM element and rendering logic.
 */

import Navigo from 'navigo';
import { ToddlerGame } from './ToddlerGame.js';
import { GamePage } from './pages/GamePage.js';
import { FaqPage } from './pages/FaqPage.js';
import { StoryListPage } from './pages/StoryListPage.js';
import { StoryViewerPage } from './pages/StoryViewerPage.js';

export function setupRouting(game: ToddlerGame): void {
    const router = new Navigo('/');

    // Instantiate pages once — they hold their own DOM references
    const pages = {
        game:        new GamePage(game),
        faq:         new FaqPage(),
        storyList:   new StoryListPage(),
        storyViewer: new StoryViewerPage(),
    };

    // Expose navigate globally so BasePage.navigate() works without a circular import
    (window as any).__appNavigate = (path: string) => router.navigate(path);

    function trackPageView(path: string): void {
        try {
            const win = window as any;
            if (typeof win.gtag === 'function') {
                win.gtag('event', 'page_view', {
                    page_path: path,
                    page_location: window.location.origin + path,
                    page_title: document.title,
                });
            }
        } catch (e) {}
    }

    router
        .on('/', () => {
            pages.game.mount();
            trackPageView('/');
        })
        .on('/faq', () => {
            pages.game.pause();
            pages.faq.mount();
            trackPageView('/faq');
        })
        .on('/stories/:id', (match) => {
            pages.game.pause();
            pages.storyViewer.mount(match?.data ?? undefined);
            trackPageView(`/stories/${match?.data?.id}`);
        })
        .on('/stories', () => {
            pages.game.pause();
            pages.storyList.mount();
            trackPageView('/stories');
        })
        .notFound(() => {
            router.navigate('/');
        });

    router.resolve();
}
